import Hero from "./Hero"
import TextboxAlignLeft from "./TextboxAlignLeft"
import ThreeItemScatter from "./ThreeItemScatter"
import RowsAlternating from "./RowsAlternating"
import ProjectGrid from "./ProjectGrid";
import ContentGrid from "./ContentGrid";
import Slideshow from "./Slideshow";
import SlideshowTextOnly from "./SlideshowTextOnly";
import ThreeColumnGrid from "./ThreeColumnGrid";
import TeamGrid from "./TeamGrid";
import AwardsMarquee from "./AwardsMarquee";
import TextTitle from "./TextTitle";
import FourColumnGrid from "./FourColumnGrid";
import CenteredCta from "./CenteredCta";
import TextMarquee from "./TextMarquee";
import ScatteredImageAndText from "./ScatteredImageAndText";
import MarginTitleGrid from "./MarginTitleGrid";
import SquareGrid from "./SquareGrid";

export default function RenderComponent({ sections }) {

    if (sections == null) {
        return;
    }

    return (

        <div className="sections">

            {sections.map((section) => (

                <div className="section" key={section.sys.id}>

                    {section.sys.contentType.sys.id === "sectionHero" && (
                        <Hero
                            heroSize={section.fields.heroSize}
                            title={section.fields.title}
                            titleBackgroundColor={section.fields.titleBackgroundColor?.value}
                            titleTextColor={section.fields.titleTextColor?.value}
                            titlePixelStyle={section.fields.titlePixelStyle}
                            titlePixelColor={section.fields.titlePixelColor?.value}
                            subtitle={section.fields.subtitle}
                            heroMedia={section.fields.media}
                            heroMediaPortrait={section.fields.portraitMedia}
                            ctaText={section.fields.ctaText}
                            ctaLink={section.fields.ctaLink}
                            ctaBackgroundColor={section.fields.ctaBackgroundColor?.value}
                            ctaTextColor={section.fields.ctaTextColor?.value}
                            ctaShape={section.fields.ctaShape}
                            ctaHdVideoLink={section.fields.ctaHdVideoLink}
                            ctaSdVideoLink={section.fields.ctaSdVideoLink}
                        />
                    )
                    }
                    {section.sys.contentType.sys.id === "sectionTextboxAlignLeft" && (
                        <TextboxAlignLeft
                            title={section.fields.title}
                            content={section.fields.content}
                            textboxButtonText={section.fields.textboxButtonText}
                            buttonLink={section.fields.buttonLink}
                            buttonColor={section.fields.buttonColor?.value}
                            buttonTextColor={section.fields.buttonTextColor?.value}

                        />)
                    }
                    {section.sys.contentType.sys.id === "sectionThreeItemScatter" && (
                        <ThreeItemScatter
                            title={section.fields.title}
                            studioTitle={section.fields.studioTitle}
                            studioColor={section.fields.studioColor.value}
                            studioVideo={section.fields.studioVideo.fields.file.url}
                            studioCaption={section.fields.studioCaption}
                            studioLink={section.fields.studioLink}
                            studioCtaText={section.fields.studioCtaText}
                            studioCtaColor={section.fields.studioCtaColor.value}
                            studioCtaBackground={section.fields.studioCtaBackground.value}
                            vfxTitle={section.fields.vfxTitle}
                            vfxColor={section.fields.vfxColor.value}
                            vfxVideo={section.fields.vfxVideo.fields.file.url}
                            vfxCaption={section.fields.vfxCaption}
                            vfxCtaText={section.fields.vfxCtaText}
                            vfxLink={section.fields.vfxLink}
                            vfxCtaColor={section.fields.vfxCtaColor.value}
                            vfxCtaBackground={section.fields.vfxCtaBackground.value}
                            labsTitle={section.fields.labsTitle}
                            labsColor={section.fields.labsColor.value}
                            labsVideo={section.fields.labsVideo.fields.file.url}
                            labsCaption={section.fields.labsCaption}
                            labsCtaText={section.fields.labsCtaText}
                            labsLink={section.fields.labsLink}
                            labsCtaColor={section.fields.labsCtaColor.value}
                            labsCtaBackground={section.fields.labsCtaBackground.value}

                        />
                    )}
                    {section.sys.contentType.sys.id === "sectionRowsAlternating" && (
                        <RowsAlternating title={section.fields.sectionTitle} items={section.fields.items} />
                    )}
                    {section.sys.contentType.sys.id === "sectionSquareGrid" && (
                        <SquareGrid title={section.fields.title} items={section.fields.items} />
                    )}
                    {section.sys.contentType.sys.id === "sectionProjectGrid" && (
                        <ProjectGrid title={section.fields.title} items={section.fields.items} />
                    )}
                    {section.sys.contentType.sys.id === "sectionContentGrid" && (
                        <ContentGrid title={section.fields.title} items={section.fields.items} />
                    )}
                    {section.sys.contentType.sys.id === "sectionMarginTitleGrid" && (
                        <MarginTitleGrid title={section.fields.title} items={section.fields.items} />
                    )}

                    {section.sys.contentType.sys.id === "sectionSlideshow" && (
                        <Slideshow title={section.fields.title} items={section.fields.slide} />
                    )}
                    {section.sys.contentType.sys.id === "sectionSlideshowTextOnly" && (
                        <SlideshowTextOnly title={section.fields.title} items={section.fields.items} />
                    )}
                    {section.sys.contentType.sys.id === "sectionThreeColumnGrid" && (
                        <ThreeColumnGrid title={section.fields.title} items={section.fields.items} />
                    )}
                    {section.sys.contentType.sys.id === "sectionTeamGrid" && (
                        <TeamGrid title={section.fields.title} teamCategories={section.fields.teamCategories} />
                    )}
                    {section.sys.contentType.sys.id === "sectionAwardsMarquee" && (
                        <AwardsMarquee title={section.fields.title} items={section.fields.items} />
                    )}
                    {section.sys.contentType.sys.id === "sectionTextTitle" && (
                        <TextTitle title={section.fields.title} />
                    )}
                    {section.sys.contentType.sys.id === "sectionFourColumnGrid" && (
                        <FourColumnGrid title={section.fields.title} items={section.fields.items} />
                    )}
                    {section.sys.contentType.sys.id === "sectionCenteredCta" && (
                        <CenteredCta
                            title={section.fields.title}
                            media={section.fields.media}
                            ctaText={section.fields.ctaText}
                            cardColor={section.fields.cardColor.value}
                            ctaColor={section.fields.ctaColor.value}
                            ctaLink={section.fields.ctaLink}
                            openLinkNew={section.fields.openLinkNew}
                        />
                    )}
                    {section.sys.contentType.sys.id === "sectionTextMarquee" && (
                        <TextMarquee
                            firstRow={section.fields.firstRow}
                            secondRow={section.fields.secondRow}
                        />
                    )}
                    {section.sys.contentType.sys.id === "sectionScatteredImageAndText" && (
                        <ScatteredImageAndText
                            media1={section.fields.media1}
                            text1={section.fields.text1}
                            media2={section.fields.media2}
                            media3={section.fields.media3}
                            text2={section.fields.text2}
                        />
                    )}

                </div>

            ))}

        </div>

    )
}